export const pageTypes = Object.freeze({
  QUOTE: 'quote',
  PURCHASE_ORDER: 'purchaseOrder',
  CHANGE_ORDER: 'changeOrder',
})
